import React, { useState, useMemo } from 'react';
import { products, categories } from '../data/products';
import ProductCard from '../components/ProductCard';
import './Products.css';

const Products = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = useMemo(() => {
    return products.filter(p => {
      const matchCat = activeCategory === 'All' || p.category === activeCategory;
      const matchSearch = p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.description.toLowerCase().includes(searchQuery.toLowerCase());
      return matchCat && matchSearch;
    });
  }, [activeCategory, searchQuery]);

  return (
    <div className="products-page">
      {/* Hero Banner */}
      <div className="products-hero">
        <div className="products-hero-bg" />
        <div className="container">
          <div className="products-hero-content">
            <span className="section-label" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Our Catalogue
            </span>
            <h1 className="products-hero-title">
              Complete Rice Mill
              <br />
              <span>Machinery Range</span>
            </h1>
            <p className="products-hero-subtitle">
              {products.length} precision-engineered machines for every stage of your milling process.
            </p>
          </div>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="products-filter-bar">
        <div className="container">
          <div className="filter-inner">
            <div className="category-pills">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`cat-pill ${activeCategory === cat ? 'active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                  {cat !== 'All' && (
                    <span className="pill-count">
                      {products.filter(p => p.category === cat).length}
                    </span>
                  )}
                </button>
              ))}
            </div>
            <div className="search-box">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                placeholder="Search products..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <button className="search-clear" onClick={() => setSearchQuery('')}>✕</button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="products-main">
        <div className="container">
          <div className="products-meta">
            <p>
              Showing <strong>{filtered.length}</strong> product{filtered.length !== 1 ? 's' : ''}
              {activeCategory !== 'All' ? ` in ${activeCategory}` : ''}
            </p>
          </div>

          {filtered.length === 0 ? (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h3>No products found</h3>
              <p>Try adjusting your search or filter.</p>
              <button onClick={() => { setSearchQuery(''); setActiveCategory('All'); }}>
                Clear filters
              </button>
            </div>
          ) : (
            <div className="products-grid">
              {filtered.map((product, i) => (
                <ProductCard key={product.id} product={product} index={i} />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* CTA Banner */}
      <div className="products-cta">
        <div className="container">
          <div className="products-cta-inner">
            <div>
              <h3>Need a custom solution?</h3>
              <p>Our engineering team designs turnkey rice mill setups tailored to your capacity and budget.</p>
            </div>
            <a href="/contact" className="products-cta-btn">Request a Quote →</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
